import { observer } from 'mobx-react-lite'
import { IconButton, Typography } from 'shared/ui'
import { DownloadPreviewBtn } from 'widgets/PresentationMode/ui/info/ui/buttons/DownloadPreviewBtn'
import { InfoWrap } from 'widgets/PresentationMode/ui/info/ui/InfoWrap/InfoWrap'
import { usePresentationModeContext } from 'widgets/PresentationMode'
import styles from './styles.module.scss'

export const InfoImagePreview = observer(({ withPagination }: { withPagination: boolean }) => {
  const { imageControllerStore } = usePresentationModeContext()
  const {
    scalePercent,
    onScaleMinus,
    onScalePlus,
    onPrevPage,
    onNextPage,
    isFirstScale,
    isLastScale,
    isFirstPage,
    isLastPage,
    page,
    numPages,
  } = imageControllerStore

  return (
    <InfoWrap
      centerActions={
        <>
          <IconButton
            disabled={isFirstScale}
            icon={'minusSquare'}
            color={'secondary'}
            variant={'icon'}
            onClick={onScaleMinus}
            ariaLabel='InfoImagePreview_scaleMinus'
          />
          <div className={styles.scalePercent}>
            <Typography variant={'body-md-regular'} ariaLabel={'scalePercent'}>
              {scalePercent}
            </Typography>
          </div>
          <IconButton
            disabled={isLastScale}
            icon={'plusSquare'}
            color={'secondary'}
            variant={'icon'}
            onClick={onScalePlus}
            ariaLabel='InfoImagePreview_scalePlus'
          />
          {withPagination && (
            <div className={styles.counterWrap}>
              <IconButton
                disabled={isFirstPage}
                icon={'arrowLeft'}
                color={'secondary'}
                variant={'icon'}
                onClick={onPrevPage}
                ariaLabel='InfoPdfPreview_prevPage'
              />
              <Typography
                variant={'body-md-regular'}
                ariaLabel={'pageInfo'}
                className={styles.counter}
                tag={'div'}
              >
                {page} / {numPages || 1}
              </Typography>
              <IconButton
                disabled={isLastPage}
                icon={'arrowRight'}
                color={'secondary'}
                variant={'icon'}
                onClick={onNextPage}
                ariaLabel='InfoPdfPreview_nextPage'
              />
            </div>
          )}
        </>
      }
      rightActions={
        <>
          <DownloadPreviewBtn />
        </>
      }
    />
  )
})
